// @flow

import { Placeholder } from '@gandi/ui';

import styles from './SummaryChoiceSkeleton.scss';

export const SummaryChoiceSkeleton = (): React.MixedElement => {
  return (
    <div className={styles.productSummary}>
      <div className={styles.productInfo}>
        <Placeholder style={{ minWidth: '5ch', height: '1.5em' }} />

        <div className={styles.productSubtitleContainer}>
          <Placeholder style={{ width: '20ch', height: '1' }} />

          <Placeholder style={{ width: '10ch' }} />
        </div>
      </div>

      <div className={styles.productAction}>
        <div className={styles.productPriceContainer}>
          <Placeholder style={{ width: '8ch' }} />
        </div>
        <Placeholder style={{ width: '13ch', height: '1.5em' }} />
      </div>
    </div>
  );
};
